import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainWrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "subtext" }

import { onMounted,inject,computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'NotCreatedPage',
  setup(__props) {

const router:any =inject(`router`)
const queryText=computed(()=>{
  return router.currentRoute.value.query.name
})
onMounted(()=>{
  window.scrollTo({top:0,behavior:'smooth'});
})

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: require(`../assets/Emoji.png`),
      alt: ""
    }, null, 8, _hoisted_2),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text" }, "UH OH", -1)),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode("Look like \"" + _toDisplayString(queryText.value) + "\" ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _cache[2] || (_cache[2] = _createTextVNode(" part still not created"))
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "subtext" }, "Sadly...", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "subtext" }, "Come back in near future", -1)),
    _createVNode(_component_BaseButton, {
      style: {"font-size":"20px"},
      color: "green",
      center: true,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
      text: "Back to Page"
    })
  ]))
}
}

})